import { emailNotification } from "../config/emailNotification";


export const renewalLicense = ( data ) => {
    return emailNotification.email( data ).then( response => response )
};
